const state = {
    active: 0,
    ajActive: 0,
    ayActive: 0,
};
const mutations = {
    SET_ACTIVE: (state, active) => {
        state.active = active;
    },
    SET_AJ_ACTIVE: (state, active) => {
        state.ajActive = active;
    },
    SET_AY_ACTIVE: (state, active) => {
        state.ayActive = active;
    },
};
const actions = {
    async sendAcive({ commit}, data) {
        commit('SET_ACTIVE', data);
    },
    async sendAJAcive({ commit}, data) {
        commit('SET_AJ_ACTIVE', data);
    },
    async sendAYAcive({ commit}, data) {
        commit('SET_AY_ACTIVE', data);
    },
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};
